/**
 * Bounded constants for the convergence rule pack.
 *
 * SOURCE: "Search x Chat Convergence - MVP Triggering Architecture", Appendix A
 * — Reference constants and representative cases.
 * https://hello.atlassian.net/wiki/spaces/jirasearch/pages/7525895377
 *
 * These are pack data, not harness behaviour: changing one requires a new pack
 * version and regenerated golden/corpus evidence. Values marked provisional in
 * the design are timing constants owned by the runtime layer and are therefore
 * absent here — this pack only classifies.
 */

/** Word-like tokens are counted up to this bound; observing token 513 commits Search. */
export const MAX_WORD_TOKENS = 512;

/** `qMatch` longer than this many Unicode code points commits Search. */
export const MAX_CODE_POINTS = 4096;

/** One or two word-like tokens is a short query. */
export const SHORT_QUERY_MAX_WORDS = 2;

/** A stop-word-stripped query needs this many tokens to claim a recent title by prefix. */
export const MIN_RECENT_PREFIX_TOKENS = 3;

/** A stop-word-stripped query needs this many tokens to claim a recent title with its words reordered. */
export const MIN_RECENT_REORDERED_TOKENS = 4;
